import React, { MutableRefObject } from 'react';
import styles from './orders.module.scss';
import useOrdersPageHook from './orders-hook';
import { ICompanyCurrentOrdersResponce } from '../../../../../Interfaces/responseTypes';
import CustomDialog from '../../../../../Components/Dialog/customDialog';
import UnlockAudioDialog from '../Dialogs/UnlockAudio/unlockAudioDialog';

export interface IOrdersPageProps {
    company_id: number,
    orders?: ICompanyCurrentOrdersResponce,
    QR: string,
    currencySymbol: string,
    audioUnlocked: MutableRefObject<boolean>,
    notificationSoundRef: MutableRefObject<HTMLAudioElement | null>
}

const OrdersPage: React.FC<IOrdersPageProps> = (props) => {
    const {
        navRef,
        navItemRefs,
        PAGE_CONTENTS,
        activeContent,
        isDialogOpen,
        ordersActions,
        onClose,
        handleNavClick
    } = useOrdersPageHook(props);
    const { audioUnlocked, notificationSoundRef } = props;


    return (
        <div className={styles.container}>
            <audio
                ref={notificationSoundRef}
                src="/Sounds/notify.mp3"
                preload="auto"
                style={{ display: "none" }}
            />
            <div className={styles.page} >
                <div className={styles.ordersPageHeader} ref={navRef}>
                    {
                        ordersActions.map((action, index) => {
                            return (
                                <div
                                    key={action.id}
                                    className={activeContent === action.id ? styles.selectedAction : styles.actionItem}
                                    onClick={() => handleNavClick(index, action.id)}
                                    ref={(el) => (navItemRefs.current[index] = el)}
                                >
                                    <img src={action.icon} alt={`${action.icon}.svg`} />
                                    <p>{action.title}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={styles.pageContent}>
                    {PAGE_CONTENTS[activeContent]}
                </div>
            </div>
            <CustomDialog
                open={isDialogOpen}
                onClose={onClose}
                children={
                    <UnlockAudioDialog
                        audioUnlocked={audioUnlocked}
                        notificationSoundRef={notificationSoundRef}
                        onClose={onClose}
                    />}
            />
        </div>
    )
}

export default OrdersPage
